export default __webpack_public_path__ + "b185eaaafd9138bd487e45c64a360b0e.svg";